import LegalPage from '@/components/Legal/LegalPage';

export default function TermsRoute() {
  return <LegalPage docKey="terms" />;
}
